// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a940a6c3","977":"f4127f61"}[chunkId] + ".chunk.js";
};